import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

// This is a multi-tenant app. Below are the supported apps.
const AssetConsoleApp = lazy(() => import('apps/asset-console/AppRouter'));
const HomeAiApp = lazy(() => import('apps/home-ai/AppRouter'));
const HomeDesignerApp = lazy(() => import('apps/home-designer/AppRouter'));
const HomeViewerApp = lazy(() => import('apps/home-viewer/AppRouter'));
const RenderingDashboardApp = lazy(() => import('apps/rendering-dashboard/AppRouter'));
const RenderingStatusApp = lazy(() => import('apps/rendering-status/AppRouter'));
const MobiusApp = lazy(() => import('apps/project-mobius/app'));
const WhProductApp = lazy(() => import('apps/wh-product/AppRouter'));

// Common error page for invalid routes.
// Apps can also implement app specific error pages for invalid sub-routes.
const ErrorPage = lazy(() => import('shared/components/ErrorPage'));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename='/apps'>
      <Suspense fallback={null}>
        <Routes>
          <Route path='/asset-console/*' element={<AssetConsoleApp />} />
          <Route path='/home-ai/*' element={<HomeAiApp />} />
          <Route path='/home-designer/*' element={<HomeDesignerApp />} />
          <Route path='/home-viewer/*' element={<HomeViewerApp />} />
          <Route path='/rendering-dashboard/*' element={<RenderingDashboardApp />} />
		  <Route path='/rendering-status/*' element={<RenderingStatusApp />} />
          <Route path='/wh-product/*' element={<WhProductApp />} />
          <Route path='/mobius' element={<MobiusApp />} />
          <Route path='*' element={<ErrorPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
